import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { Task, GetTasksResponse } from "../types";
import { THIS_SESSION_GROUP_SLUG, TODO_GROUP_SLUG } from "../types";
export function useOrganizableTasks() {
  const $ = _c(13);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [...QUERY_KEYS.tasks.infinite(THIS_SESSION_GROUP_SLUG), "organizable"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== apiFetcher) {
    t1 = {
      queryKey: t0,
      queryFn: () => apiFetcher(`/api/v1/tasks?page=1&limit=100&groupSlug=${THIS_SESSION_GROUP_SLUG}`),
      staleTime: 60000,
      gcTime: 300000
    };
    $[1] = apiFetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: thisSessionData,
    isLoading: isLoadingThisSession
  } = useQuery(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [...QUERY_KEYS.tasks.infinite(TODO_GROUP_SLUG), "organizable"];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== apiFetcher) {
    t3 = {
      queryKey: t2,
      queryFn: () => apiFetcher(`/api/v1/tasks?page=1&limit=100&groupSlug=${TODO_GROUP_SLUG}`),
      staleTime: 60000,
      gcTime: 300000
    };
    $[4] = apiFetcher;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: todoData,
    isLoading: isLoadingTodo
  } = useQuery(t3);
  const isLoading = isLoadingThisSession || isLoadingTodo;
  let t4;
  bb0: {
    if (isLoading || !thisSessionData || !todoData) {
      let t5;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[6] = t5;
      } else {
        t5 = $[6];
      }
      t4 = t5;
      break bb0;
    }
    let t5;
    if ($[7] !== thisSessionData.data || $[8] !== todoData.data) {
      const thisSessionTasks = (thisSessionData.data || []) as Task[];
      const todoTasks = (todoData.data || []) as Task[];
      const filterTask = _temp;
      t5 = [...thisSessionTasks.filter(filterTask).map(_temp2), ...todoTasks.filter(filterTask).map(_temp3)];
      $[7] = thisSessionData.data;
      $[8] = todoData.data;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    const combined = t5;
    t4 = combined;
  }
  const processedTasks = t4;
  let t5;
  if ($[10] !== isLoading || $[11] !== processedTasks) {
    t5 = {
      data: processedTasks,
      isLoading,
      error: null
    };
    $[10] = isLoading;
    $[11] = processedTasks;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp3(t_0) {
  return {
    ...t_0,
    _sourceGroup: TODO_GROUP_SLUG
  };
}
function _temp2(t) {
  return {
    ...t,
    _sourceGroup: THIS_SESSION_GROUP_SLUG
  };
}
function _temp(task) {
  return !task.completedAt;
}